import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveQuestion } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveQuestionActivity = ({ values }: IProjectActivity<IProjectActivityRemoveQuestion>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveQuestion')}
      <b>{values.question}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
